import { LoansSideNav } from './LoansSideNav';

export default LoansSideNav;
